var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-body"},[_c('studyTable',{attrs:{"tableData":_vm.tableDataTemp,"columns":_vm.columns,"num":_vm.num,"pages":_vm.pages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }